/**
 * Route for `publisher-url-override`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherUrlOverridePage } from "../features/publisher-url-override/PublisherUrlOverridePage";

export const publisherUrlOverrideRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-url-override",
	component: PublisherUrlOverridePage,
});

export default publisherUrlOverrideRoute;
